import {
    Avatar,
    Clickable, Col, Divider, Icon, Row, Sidepanel, Spinner2, Text
} from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SearchUsers } from 'screens/Admin/components';
import { ListItem } from './components';

const Athletes = ({ visible, closeModal, user }) => {
  const [athletes, setAthletes] = useState(null),
    [loading, setLoading] = useState(true),
    [dataId, setDataId] = useState(null),
    [selectedAthlete, setSelectedAthlete] = useState(null),
    athleteIds = athletes?.map((x) => x._id),
    dispatch = useDispatch();

  useEffect(() => {
    if (!visible || athletes?.length) return;

    setTimeout(() => fetch(), 300);
  }, [visible]);

  async function fetch() {
    const res = await Api.post('/users/getTeamMembers', { teamId: user._id });
    if (!res) return;

    setAthletes(res);
    setLoading(false);
  }

  function filterAthletes(removedId) {
    setAthletes(athletes.filter((x) => x._id !== removedId));
  }

  async function addAthlete(item) {
    const res = await Api.post('/admin/addToTeam', { teamId: user._id, userId: item._id });
    if (!res) return;

    const newAthletes = [res, ...athletes];
    setAthletes(newAthletes);

    dispatch({
      type: 'ADMIN_EDIT_USER',
      payload: { _id: user._id, athletes: newAthletes }
    });
  }

  return (
    <Sidepanel pad="24px 0" wid={600} visible={visible} closeModal={closeModal}>
      <Col>
        <Row pad="0 24px 24px" wid="calc(100% - 48px)" start noFlex>
          <Col center>
            <Clickable onClick={closeModal}>
              <Icon type="arrowLeft" dimensions={20} marg="0 12px 0 0" />
            </Clickable>
          </Col>

          <Avatar user={user} wid="100%" />

          <Row between wid="100%" ht="100%">
            <Col marg="0 0 0 10px" between ht="100%">
              <Col noFlex>
                <Text med>{user.name}</Text>
                <Text c1 med col={theme.GREY_60}>
                  @{user.username}
                </Text>
              </Col>

              <Text b2>{user.athletes?.length || 0} athletes</Text>
            </Col>

            <Text b2>{user.sport && user.sport + ' club'}</Text>
          </Row>
        </Row>

        <Divider />

        {loading ? (
          <Col ht="100%" center pad="24px 0">
            <Spinner2 />
          </Col>
        ) : (
          <Col pad="24px 0" start wid="100%">
            <Col wid="calc(100% - 48px)" noFlex center>
              <SearchUsers
                title="Search for athletes to add to this team"
                // sport={user.sport}
                userType="athlete"
                handleSelect={addAthlete}
                selected={selectedAthlete}
                exclude={athleteIds}
                wid="calc(100% - 32px)"
              />
            </Col>

            {athletes?.map((item, i) => (
              <ListItem
                key={item._id}
                item={item}
                teamId={user._id}
                athletes={athletes}
                filterAthletes={filterAthletes}
              />
            ))}
          </Col>
        )}
      </Col>
    </Sidepanel>
  );
};

export default Athletes;
